import { Component } from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-rapport',
  templateUrl: './rapport.component.html',
  styleUrls: ['./rapport.component.scss']
})
export class RapportComponent {}
